export enum Volume {
    LESS_500000 = '1E',
    BETWEEN_500001_1000000 = '2E',
    BETWEEN_1000001_10000000 = '3E',
    MORE_10000000 = '4E',
}
